module.exports = __webpack_public_path__ + "img/3.ddc84e7c.png";